import React, { useRef, useState, useEffect } from 'react'
import './PropertySearch.scss'
import InputBase from '@material-ui/core/InputBase'
import { Close, ArrowForwardIos } from '@material-ui/icons'
import { debounce } from '@engine/utils/jsUtils'
import PropTypes from 'prop-types'
import { PropertySearchItem } from '@components/custom'

const PropertySearch = props => {
  const { propertiesData, getPropertyInfo, closeSourceDialog } = props
  const searchText = useRef('')
  const [propertyDetails, setPropertyDetails] = useState([])
  const [closeIconDisplay, setCloseIconDisplay] = useState(false)

  useEffect(() => {
    if (searchText.current.value) {
      setPropertyDetails(propertiesData.data)
    }
  }, [propertiesData.data, searchText.current.value])

  useEffect(() => {
    if (!closeSourceDialog) {
      clearSearch()
    }
  }, [closeSourceDialog])

  const clearSearch = () => {
    searchText.current.value = ''
    setPropertyDetails([])
    setCloseIconDisplay(false)
  }

  const handleChange = propertyName => {
    setCloseIconDisplay(true)
    props.getProperties(propertyName)
  }

  const handleListItemFocusTransfer = e => {

      const focusableDivElements = document.querySelectorAll('.property-list-item')

      if (!focusableDivElements?.length) {
        return
      }

      // Creating an array from the node list
      const focusable = [...focusableDivElements]

      // get the index of current item
      const index = focusable.indexOf(document.querySelector('.property-list-item.focused'))

      // Create a variable to store the idex of next item to be focussed
      let nextIndex = 0

      if (e.keyCode === 38) {
        // Up arrow
        e.preventDefault()
        nextIndex = index > 0 ? index - 1 : index
        if (focusableDivElements[nextIndex] && index !== 0) {
          if (index > 0) {
            focusableDivElements[index].className = 'property-list-item'
          }
          focusableDivElements[nextIndex].className += ' focused'
          focusableDivElements[nextIndex].scrollIntoView({ block: 'nearest' })
        }

      } else if (e.keyCode === 40) {
        // Down arrow
        e.preventDefault()
        nextIndex = index + 1 < focusable.length ? index + 1 : index
        if (focusableDivElements[nextIndex] && index !== focusable.length - 1) {
          if (index >= 0) {
            focusableDivElements[index].className = 'property-list-item'
          }
          focusableDivElements[nextIndex].className += ' focused'
          focusableDivElements[nextIndex].scrollIntoView({ block: 'nearest' })
        }
      } else if (e.keyCode === 13) {
        // Enter key
        if (focusableDivElements[index]) {
          focusableDivElements[index].click()
        }
      }
  }

  const debouncedChange = debounce(handleChange, 300)

  return (

    <div>
      <div data-testid="property-search-tab" className="property-search-tab">
        <div className="property-search-title-container">
          <ArrowForwardIos className="arrow-forward" />
          <div className="property-search-title">Property Search</div>
        </div>
      </div>

      <div className="property-search-area">
        <InputBase
          autoFocus={true}
          className="search"
          placeholder="Enter property name"
          inputProps={{ 'data-testid': 'property-search' }}
          onChange={e => debouncedChange(e.target.value)}
          inputRef={searchText}
          onKeyDown={e => {
              // Up Arrow / Down Arrow / Enter key
              if (e.keyCode === 38 || e.keyCode === 40 || e.keyCode === 13) {
                handleListItemFocusTransfer(e)
              }
            }
          }
        />
      </div>

      {
        closeIconDisplay && (
          <div className="close-enable-wrapper">
            <Close data-testid="clear-search" className="cancel-icon" onClick={clearSearch} aria-label="advanced-options" />
          </div>
        )
      }

        <div className="property-options" id="property-options" data-testid="property-options">
          <PropertySearchItem propertySearchDetails={propertyDetails} closeIconDisplay={closeIconDisplay} getPropertyInfo={getPropertyInfo} />
        </div>
    </div>

  )
}

PropertySearch.propTypes = {
  getProperties: PropTypes.func,
  propertiesData: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
  getPropertyInfo: PropTypes.func,
  closeSourceDialog: PropTypes.bool
}

export default PropertySearch
